<template>
  <div class="page-container">
    <div class="content-wrap">
      <TopNavBar/>

      <b-container class="ga-text-page-container">
        <b-row>
          <b-col class="d-none d-md-block col-md-1 col-lg-2"></b-col>
          <b-col class="col-12 col-md-10 col-lg-8">
            <article class="ga-tool-page ga-auth-page">
              <header class="ga-tool-page__header">
                <h1 class="ga-tool-page__title">{{ $t('Login') }}</h1>
              </header>

              <b-form @submit.prevent="submit">
                <label class="ga-form__label" for="login-username">{{ $t('Username:') }}</label>
                <input
                  id="login-username"
                  type="text"
                  class="ga-form__input"
                  :placeholder="$t('Enter username')"
                  v-model="username"
                  autocomplete="username"
                >

                <label class="ga-form__label" for="login-password">{{ $t('Password:') }}</label>
                <input
                  id="login-password"
                  type="password"
                  class="ga-form__input"
                  :placeholder="$t('Enter password here')"
                  v-model="password"
                  autocomplete="current-password"
                >

                <div v-if="error" class="ga-form__error">{{ error }}</div>

                <vue-recaptcha
                  v-if="showRecaptchaWidget"
                  :sitekey="recaptchaSiteKey"
                  @expired="onCaptchaExpired"
                  @verify="onCaptchaVerified"
                  ref="recaptcha"
                  size="invisible"
                ></vue-recaptcha>

                <div class="ga-tool-page__actions">
                  <button type="submit" class="ga-form__btn">{{ $t('Login') }}</button>
                </div>
              </b-form>

              <router-link
                :to="{ name: 'auth.password_reset_email' }"
                class="ga-auth-page__footer-link"
              >{{ $t('Forgot password?') }}</router-link>
            </article>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import TopNavBar from '../../components/TopNavBar'
import { AuthService } from '../../services/auth.service'
import VueRecaptcha from 'vue-recaptcha'
import { recaptchaLoadMixin } from '../../mixins/recaptchaLoadMixin'
import { API_URL, RECAPTCHA_SITE_KEY } from '../../env'
import axios from 'axios'

export default {
  name: 'Login',
  mixins: [recaptchaLoadMixin],
  data () {
    return {
      username: '',
      password: '',
      remember_me: false,
      error: '',
      recaptchaSiteKey: RECAPTCHA_SITE_KEY
    }
  },
  methods: {
    onCaptchaExpired: function () {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
    skipRecaptcha () {
      return !this.recaptchaSiteKey || this.recaptchaSiteKey === 'secretKey'
    },
    submit: function () {
      if (this.skipRecaptcha()) {
        this.doLogin()
        return
      }
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.execute()
      }
    },
    doLogin () {
      AuthService.makeLogin({ username: this.username, password: this.password })
        .then((response) => {
          this.$router.push({ name: 'home' })
          this.error = ''
        })
        .catch((error) => {
          if (!error) {
            this.error = 'Username or password mismatch'
          } else if (error.message.username) {
            this.error = this.$t('Username:') + ' ' + this.$t(error.message.username)
          } else if (error.message.password) {
            this.error = this.$t('Password:') + ' ' + this.$t(error.message.password)
          } else if (error.message.non_field_errors) {
            this.error = this.$t('Username:') + '/' + this.$t('Password:') + ' ' + this.$t(error.message.non_field_errors)
          } else {
            this.error = error.message
          }
        })
    },
    onCaptchaVerified (recaptchaToken) {
      const token = recaptchaToken
      this.$refs.recaptcha.reset()

      axios.post(`${API_URL}/auth/recapcha/`, { token: token })
        .then(response => {
          if (response.data.status) {
            this.doLogin()
          } else {
            this.error = this.$t('Captcha verification failed')
          }
        })
    }
  },
  components: { TopNavBar, VueRecaptcha }
}
</script>
